module.exports = {
          srcSet: __webpack_public_path__ + "d33bd874d4a50baef1a69066ea09da2b-20.png"+" 20w",
          images:[ {path: __webpack_public_path__ + "d33bd874d4a50baef1a69066ea09da2b-20.png",width: 20,height: 19}],
          src: __webpack_public_path__ + "d33bd874d4a50baef1a69066ea09da2b-20.png",
          toString:function(){return __webpack_public_path__ + "d33bd874d4a50baef1a69066ea09da2b-20.png"},
          
          width: 20,
          height: 19
        }